
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cgy29", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aWwYt = parcelRequire("aWwYt");


var $cMvMc = parcelRequire("cMvMc");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $brNvA = parcelRequire("brNvA");


var $cZa7r = parcelRequire("cZa7r");


var $4DJgG = parcelRequire("4DJgG");

const $dacb5f0322f4a333$export$5ae138a5a05281f1 = ({ contentId: contentId, isFabric: isFabric, sendKeyboardShortcutAnalytics: sendKeyboardShortcutAnalytics })=>{
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setSelectionOptionsForCreateEditor: setSelectionOptionsForCreateEditor } = (0, $cZa7r.useAnnotationsDispatch)();
    const { createComment: createComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { commentToReattach: commentToReattach } = (0, $brNvA.useReattachComment)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const content = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        content.current = document.querySelector('div#content');
    }, []);
    const createReactInlineCommentHighlight = ({ experienceAttributes: experienceAttributes } = {})=>{
        if (isObjectSidebarShown) hideObjectSidebar();
        if (isFabric) setSelectionOptionsForCreateEditor({
            experienceAttributes: experienceAttributes
        });
        else if (content.current) createComment((0, $4DJgG.getLegacyConvertedSelectionObj)({
            content: content,
            contentId: contentId,
            commentToReattach: commentToReattach
        }));
    };
    const handleCommentButtonClick = ({ dialogs: dialogs, shortcut: shortcut, experienceAttributes: experienceAttributes })=>{
        if (hasContentChanged) dialogs.showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>createReactInlineCommentHighlight({
                    experienceAttributes: experienceAttributes
                })
        });
        else createReactInlineCommentHighlight({
            experienceAttributes: experienceAttributes
        });
        if (shortcut) sendKeyboardShortcutAnalytics(shortcut);
    };
    return {
        handleCommentButtonClick: handleCommentButtonClick
    };
};
module.exports["useCreateCommentAction"] = $dacb5f0322f4a333$export$5ae138a5a05281f1;

});

parcelRegister("izhdc", function(module, exports) {

var $8i27m = parcelRequire("8i27m");

const $fd72c77cd5bf52d0$export$8a92cb9a88bcfd3b = (currentlyRenderedThreads, unresolvedInlineComments)=>{
    // Grab everything on the screen as a set for quick access
    const allRenderedInlineCommentIds = new Set(unresolvedInlineComments);
    // Grab all of the refs for inline comments that are available on the panel
    const panelCommentRefs = currentlyRenderedThreads.map((comment)=>{
        if (comment.type === 'INLINE') {
            if ('inlineMarkerRef' in comment && comment.inlineMarkerRef) return {
                ref: comment.inlineMarkerRef,
                type: (0, $8i27m.CommentType).INLINE
            };
            else return {
                ref: '',
                type: (0, $8i27m.CommentType).INLINE
            };
        } else return {
            ref: comment.id,
            type: (0, $8i27m.CommentType).GENERAL
        };
    }).filter((comment)=>{
        return comment.ref !== '';
    });
    // Grab the refs that we can navigate too (aka the ones rendered on the page, so open (i.e. not resolved) comments)
    const navigableInlineCommentRefs = new Set(panelCommentRefs.map((comment)=>{
        if (comment.type === (0, $8i27m.CommentType).INLINE) return allRenderedInlineCommentIds.has(comment.ref) ? comment.ref : '';
        else return comment.ref;
    }));
    return {
        panelCommentRefs: panelCommentRefs,
        navigableInlineCommentRefs: navigableInlineCommentRefs
    };
};
const $fd72c77cd5bf52d0$export$6fbaa3cb5c58ff29 = (action, panelCommentRefs, currentlySelectedThreadKey)=>{
    let nextIndex = panelCommentRefs.findIndex((comment)=>{
        return comment.ref === currentlySelectedThreadKey;
    });
    if (nextIndex === -1) nextIndex = 0;
    else if (action === 'next') nextIndex = (nextIndex + 1) % panelCommentRefs.length;
    else nextIndex = (nextIndex - 1 + panelCommentRefs.length) % panelCommentRefs.length;
    return panelCommentRefs[nextIndex];
};
const $fd72c77cd5bf52d0$export$46b037fca0ede95d = (action, currentIndex, totalComments, footerCommentsLoadingState)=>{
    const isAtBeginning = currentIndex === 0;
    const isAtEnd = currentIndex === totalComments - 1;
    if (footerCommentsLoadingState === (0, $8i27m.FooterCommentsLoadingStateType).NOT_LOADED) {
        if (isAtEnd && action === 'next' || isAtBeginning && action === 'previous') return true;
    } else if (footerCommentsLoadingState === (0, $8i27m.FooterCommentsLoadingStateType).PARTIALLY_LOADED) {
        if (isAtBeginning && action === 'previous') return true;
    }
    return false;
};
module.exports["parsePanelAndInlineRefs"] = $fd72c77cd5bf52d0$export$8a92cb9a88bcfd3b;
module.exports["getNextRef"] = $fd72c77cd5bf52d0$export$6fbaa3cb5c58ff29;
module.exports["isNavigatingToPotentiallyUnloadedFooterComment"] = $fd72c77cd5bf52d0$export$46b037fca0ede95d;

});

parcelRegister("gSkOQ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6lAIr = parcelRequire("6lAIr");


var $i6UMJ = parcelRequire("i6UMJ");


var $9wGTI = parcelRequire("9wGTI");


var $8i27m = parcelRequire("8i27m");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");

const $89de80864b4e19fe$export$618f651f678380bf = ()=>{
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, commentsDataMap: legacyCommentsDataMap, removedThreadsMap: removedThreadsMap } = (0, $8i27m.useCommentsDataState)();
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    const commentsDataMap = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? processedCommentsData.commentsDataMap : legacyCommentsDataMap;
    return (0, $42omo.useMemo)(()=>{
        const footerCommentThreads = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? (0, $6lAIr.getVisibleCommentThreads)({
            commentsDataMap: commentsDataMap,
            includeGeneralComments: true,
            includeInlineComments: false,
            orderedAnnotationIds: (0, $i6UMJ.getAnnotationThreadKeys)(orderedActiveAnnotationIdList)
        }) : (0, $i6UMJ.getOpenCommentThreads)({
            commentsDataMap: commentsDataMap,
            showInlineComments: false,
            showGeneralComments: true,
            location: (0, $i6UMJ.LocationValue).FOOTER,
            orderedActiveAnnotationIdList: orderedActiveAnnotationIdList,
            removedThreadsMap: removedThreadsMap
        });
        const footerCommentIds = footerCommentThreads.map((thread)=>thread.id);
        return {
            footerCommentIds: footerCommentIds,
            footerCommentThreads: footerCommentThreads
        };
    }, [
        commentsDataMap,
        orderedActiveAnnotationIdList,
        removedThreadsMap
    ]);
};
module.exports["useFooterComments"] = $89de80864b4e19fe$export$618f651f678380bf;

});

parcelRegister("hd53J", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ln0hx = parcelRequire("ln0hx");

var $1kHsc = parcelRequire("1kHsc");


var $aSsfA = parcelRequire("aSsfA");


var $NYiei = parcelRequire("NYiei");


var $kgNLQ = parcelRequire("kgNLQ");


var $2eC70 = parcelRequire("2eC70");


var $4L9ve = parcelRequire("4L9ve");

// Initiates the loading of all comment data for the specified page in the background
// This component is also responsible for processing the raw comments data and updating
// the ProcessedCommentsDataStore with categorized results using default contentStatus filters.
// Experience tracking constants
const $52b7f7492d78c524$var$COMMENTS_DATA_BACKGROUND_LOAD_EXPERIENCE = 'comments-data-background-load';
const $52b7f7492d78c524$export$bdd232a9ca677e73 = ({ contentId: contentId })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { setProcessedData: setProcessedData, setError: setError, setRefetch: setRefetch } = (0, $4L9ve.useProcessedCommentsDataActions)();
    // Call the hook to load all comments - should only when content has settled and is ready so we
    // don't impact loading times
    // Always fetch with network-only to ensure we get fresh data
    const { loading: loading, error: error, data: data, refetch: refetch } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: !contentId,
            fetchPolicy: 'network-only'
        }
    });
    // Set refetch function in store whenever it changes
    (0, $42omo.useEffect)(()=>{
        if (refetch) setRefetch(refetch);
    }, [
        refetch,
        setRefetch
    ]);
    // Process and update the ProcessedCommentsDataStore when data changes
    // This is the ONLY place where the processed data store should be updated
    (0, $42omo.useEffect)(()=>{
        // Don't process data while loading
        if (loading) return;
        if (error) {
            // Set error state in the store
            setError(error);
            return;
        }
        // Filter out null nodes and create array (empty array if no data)
        const allComments = (data?.comments?.nodes || []).filter((node)=>node !== null);
        // Categorize comments using default contentStatus filters
        const contentStatusFilters = (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode);
        const categorized = (0, $kgNLQ.categorizeComments)(allComments, contentStatusFilters);
        // Update the processed data store with categorized results
        // Note: refetch is set separately via setRefetch, so we don't include it here
        setProcessedData({
            allComments: allComments,
            ...categorized,
            isDataProcessed: true
        });
    }, [
        data,
        loading,
        error,
        pageMode,
        setProcessedData,
        setError
    ]);
    // Experience tracking: Handle success/failure when loading completes
    (0, $42omo.useEffect)(()=>{
        if (!contentId) return;
        // Only track completion if we're not still loading
        if (!loading) {
            if (error) // Experience failed due to error
            experienceTracker.fail({
                name: $52b7f7492d78c524$var$COMMENTS_DATA_BACKGROUND_LOAD_EXPERIENCE,
                error: error
            });
            else // Experience succeeded - comments data loaded successfully
            experienceTracker.succeed({
                name: $52b7f7492d78c524$var$COMMENTS_DATA_BACKGROUND_LOAD_EXPERIENCE
            });
        }
    }, [
        loading,
        error,
        contentId,
        experienceTracker
    ]);
    // This component only triggers the hook, doesn't render anything other than the ExperienceStart,
    // which handles being rendered multiple times with the same props gracefully
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: $52b7f7492d78c524$var$COMMENTS_DATA_BACKGROUND_LOAD_EXPERIENCE,
        attributes: {
            ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
            contentId: contentId
        }
    });
};
module.exports["CommentsDataBackgroundLoader"] = $52b7f7492d78c524$export$bdd232a9ca677e73;

});

parcelRegister("dJ5r4", function(module, exports) {
$parcel$export(module.exports, "ViewCommentShortcutListener", () => (parcelRequire("fPcdI")).ViewCommentShortcutListener);

var $fPcdI = parcelRequire("fPcdI");


});

parcelRegister("fPcdI", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $21K7m = parcelRequire("21K7m");


var $inPa6 = parcelRequire("inPa6");


var $9FoVw = parcelRequire("9FoVw");


var $aHcFH = parcelRequire("aHcFH");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $liGyh = parcelRequire("liGyh");


var $dANtQ = parcelRequire("dANtQ");


var $9QIM2 = parcelRequire("9QIM2");


var $fNzRA = parcelRequire("fNzRA");


var $k8e76 = parcelRequire("k8e76");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $cMvMc = parcelRequire("cMvMc");


var $8aF6s = parcelRequire("8aF6s");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $2eC70 = parcelRequire("2eC70");


var $aJPUt = parcelRequire("aJPUt");


var $inDu6 = parcelRequire("inDu6");


var $6GD8y = parcelRequire("6GD8y");


var $gnkil = parcelRequire("gnkil");


var $gczDe = parcelRequire("gczDe");


var $7qvmT = parcelRequire("7qvmT");


var $6KwrO = parcelRequire("6KwrO");


var $3mVfX = parcelRequire("3mVfX");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $9wGTI = parcelRequire("9wGTI");


var $aSsfA = parcelRequire("aSsfA");


var $cgy29 = parcelRequire("cgy29");


var $dkkKv = parcelRequire("dkkKv");


var $8i27m = parcelRequire("8i27m");


var $f5Wgm = parcelRequire("f5Wgm");


var $fHAwL = parcelRequire("fHAwL");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");


var $izhdc = parcelRequire("izhdc");


var $gSkOQ = parcelRequire("gSkOQ");

const $c392465906bed01c$var$ViewCommentShortcutListenerComponent = ({ isFabricPage: isFabricPage, contentId: contentId, dialogs: dialogs })=>{
    const { navigateToInlineComment: navigateToInlineComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { activeHighlight: activeHighlight } = (0, $9jl6v.useInlineCommentsContext)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { removeCommentQueryParams: removeCommentQueryParams } = (0, $liGyh.useInlineCommentQueryParams)();
    const { unresolvedInlineComments: unresolvedInlineComments } = (0, $k8e76.useInlineCommentsState)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, commentsDataMap: legacyCommentsDataMap, footerCommentsLoadingState: footerCommentsLoadingState } = (0, $8i27m.useCommentsDataState)();
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    const commentsDataMap = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? processedCommentsData.commentsDataMap : legacyCommentsDataMap;
    const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
    const pageClass = (0, $9QIM2.usePageClass)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isNextCommentLoading, setIsNextCommentLoading] = (0, $42omo.useState)(false);
    const [alreadyFetchedInitialData, setAlreadyFetchedInitialData] = (0, $42omo.useState)(false);
    const [triggeredByUnreadKeyboardShortcut, setTriggeredByUnreadKeyboardShortcut] = (0, $42omo.useState)(false);
    // Used to facilitate loading footer comments and navigating after load
    // Should only be set when confluence_frontend_kb_footer_loading is true
    const [pendingStandaloneAction, setPendingStandaloneAction] = (0, $42omo.useState)(null);
    const [{ currentlyRenderedThreads: currentlyRenderedThreads, currentlySelectedThreadKey: currentlySelectedThreadKey }, { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey }] = (0, $3mVfX.useCommentsPanel)();
    const { scrollCommentsPanelToThread: scrollCommentsPanelToThread } = (0, $6KwrO.useCommentsPanelScroll)();
    const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = (0, $aWwYt.useObjectSidebarState)();
    const { expandCommentContainer: expandCommentContainer, setFooterEditorEntry: setFooterEditorEntry } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { expanded: expanded, isObjectCommentWrapperVisible: isObjectCommentWrapperVisible, footerEditorEntry: footerEditorEntry } = (0, $fNzRA.useObjectCommentContext)();
    const { addFooterCommentAdf: addFooterCommentAdf } = (0, $3mVfX.useCommentsPanelState)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId ?? '');
    const orderedActiveAnnotations = (0, $42omo.useMemo)(()=>{
        return (0, $9wGTI.fg)('confluence_frontend_new_comments_scrolling') ? orderedActiveAnnotationIdList.map((a)=>a.threadKey) : unresolvedInlineComments;
    }, [
        orderedActiveAnnotationIdList,
        unresolvedInlineComments
    ]);
    (0, $42omo.useEffect)(()=>{
        setIsNextCommentLoading(false);
    }, [
        activeHighlight,
        currentlySelectedThreadKey
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            setCurrentlySelectedThreadKey('');
        };
    }, [
        setCurrentlySelectedThreadKey
    ]);
    const { footerCommentThreads: footerCommentThreads, footerCommentIds: footerCommentIds } = (0, $gSkOQ.useFooterComments)();
    const { unreadInlineComments: unreadInlineComments, unreadGeneralComments: unreadGeneralComments } = (0, $42omo.useMemo)(()=>{
        const unreadInlineComments = [];
        const unreadGeneralComments = [];
        orderedActiveAnnotations.forEach((threadKey)=>{
            const commentData = commentsDataMap.inline[threadKey];
            if (commentData) {
                let isCommentUnread = false;
                let hasUnreadReplies = false;
                if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) {
                    // Use unreadCommentIDSet when feature flag is enabled
                    // in SSR, unreadCommentIDSet is undefined
                    isCommentUnread = unreadCommentIDSet?.has(commentData.id);
                    hasUnreadReplies = commentData.replies?.some((reply)=>unreadCommentIDSet?.has(reply.id)) || false;
                } else {
                    // Use legacy .isUnread field when feature flag is disabled
                    isCommentUnread = commentData.isUnread || false;
                    hasUnreadReplies = commentData.replies?.some((reply)=>reply.isUnread) || false;
                }
                if (isCommentUnread || hasUnreadReplies) unreadInlineComments.push(threadKey);
            }
        });
        Object.keys(commentsDataMap.general).forEach((threadKey)=>{
            const commentData = commentsDataMap.general[threadKey];
            if (commentData) {
                let isCommentUnread = false;
                let hasUnreadReplies = false;
                if ((0, $9wGTI.fg)('confluence_frontend_unread_comments_fixes')) {
                    // Use unreadCommentIDSet when feature flag is enabled
                    isCommentUnread = unreadCommentIDSet?.has(commentData.id);
                    hasUnreadReplies = commentData.replies?.some((reply)=>unreadCommentIDSet?.has(reply.id)) || false;
                } else {
                    // Use legacy .isUnread field when feature flag is disabled
                    isCommentUnread = commentData.isUnread || false;
                    hasUnreadReplies = commentData.replies?.some((reply)=>reply.isUnread) || false;
                }
                if (isCommentUnread || hasUnreadReplies) unreadGeneralComments.push(threadKey);
            }
        });
        return {
            unreadInlineComments: unreadInlineComments,
            unreadGeneralComments: unreadGeneralComments
        };
    }, [
        commentsDataMap,
        orderedActiveAnnotations,
        unreadCommentIDSet
    ]);
    const sendKeyboardShortcutAnalytics = (shortcut)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'viewPage',
                action: 'pressed',
                actionSubject: 'keyboardShortcut',
                actionSubjectId: 'createComment',
                attributes: {
                    key: shortcut
                }
            }
        }).fire();
    };
    const { handleCommentButtonClick: handleCommentButtonClick } = (0, $cgy29.useCreateCommentAction)({
        contentId: contentId || '',
        isFabric: isFabricPage,
        sendKeyboardShortcutAnalytics: sendKeyboardShortcutAnalytics
    });
    const getCommentIndex = (0, $42omo.useCallback)((currentThreadKey)=>{
        return (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? [
            ...orderedActiveAnnotations,
            ...footerCommentIds
        ]?.findIndex((threadKey)=>threadKey === currentThreadKey) : orderedActiveAnnotations?.findIndex((threadKey)=>threadKey === currentThreadKey);
    }, [
        orderedActiveAnnotations,
        footerCommentIds
    ]);
    const openInlineComment = (0, $42omo.useCallback)((markerRef)=>{
        if ((pageClass === 'renderer' || pageClass === 'editor') && (0, $9wGTI.fg)('confluence_frontend_view_inline_comment_keyboard')) experienceTracker.start({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
            attributes: {
                ...(0, $2eC70.getCommentsDataManagerExperimentAttributes)(),
                annotationId: markerRef,
                entryPoint: 'comments-shortcuts/ViewCommentShortcutListener',
                pageClass: 'renderer'
            }
        });
        setCurrentlySelectedThreadKey('');
        const commentElement = document.getElementById(markerRef);
        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
            annotationId: markerRef
        });
        (0, $4EKKB.selectInlineComment).debug(`Keyboard selection now triggering annotation selection for annotation ${markerRef}`);
        emitter.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: [
                markerRef
            ],
            eventTarget: commentElement
        });
        if ((0, $9wGTI.fg)('confluence_comments_unified_navigation')) (0, $9FoVw.handleKeyboardShortcutNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            annotationId: markerRef,
            commentType: (0, $f5Wgm.CommentType).INLINE,
            isCommentsPanelOpen: isObjectSidebarShown && (0, $9wGTI.fg)('confluence-frontend-comments-panel'),
            hasKeyPressed: true
        });
        else (0, $aHcFH.scrollCommentIntoView)({
            commentElement: commentElement,
            isFabricPage: true
        });
    }, [
        emitter,
        setCurrentlySelectedThreadKey,
        experienceTracker,
        pageClass,
        isObjectSidebarShown
    ]);
    const scrollToFooterComment = (0, $42omo.useCallback)((threadKey)=>{
        setCurrentlySelectedThreadKey(threadKey);
        emitter.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: [],
            eventTarget: null
        });
        if ((0, $9wGTI.fg)('confluence_comments_unified_navigation')) (0, $9FoVw.handleKeyboardShortcutNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            annotationId: threadKey,
            commentType: (0, $f5Wgm.CommentType).FOOTER,
            isCommentsPanelOpen: isObjectSidebarShown && (0, $9wGTI.fg)('confluence-frontend-comments-panel'),
            hasKeyPressed: true
        });
        else (0, $7qvmT.handlePanelSelectionAndScroll)({
            threadKey: threadKey,
            isResolved: false,
            pageMode: pageMode,
            setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey,
            eventEmitter: emitter,
            commentType: (0, $8i27m.CommentType).GENERAL
        });
    }, [
        emitter,
        pageMode,
        setCurrentlySelectedThreadKey,
        isObjectSidebarShown
    ]);
    const onNavigationClick = (0, $42omo.useCallback)((nextMarkerRef)=>{
        if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                openInlineComment(nextMarkerRef);
            }
        });
        else openInlineComment(nextMarkerRef);
    }, [
        hasContentChanged,
        resetContentChanged,
        showModal,
        openInlineComment
    ]);
    const handlePanelCommentNavigation = (0, $42omo.useCallback)((action)=>{
        // If nothing is on the panel, there's nothing to navigate to
        if (currentlyRenderedThreads.length === 0) return;
        const { panelCommentRefs: panelCommentRefs, navigableInlineCommentRefs: navigableInlineCommentRefs } = (0, $izhdc.parsePanelAndInlineRefs)(currentlyRenderedThreads, orderedActiveAnnotations);
        const nextRef = (0, $izhdc.getNextRef)(action, panelCommentRefs, currentlySelectedThreadKey);
        // Use unified keyboard shortcut navigation for panel navigation when feature is enabled
        if ((0, $9wGTI.fg)('confluence_comments_unified_navigation')) {
            // Handle panel selection state management in the listener
            setCurrentlySelectedThreadKey(nextRef.ref);
            (0, $9FoVw.handleKeyboardShortcutNavigation)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                block: 'center',
                annotationId: nextRef.ref,
                commentType: nextRef.type === (0, $8i27m.CommentType).GENERAL ? (0, $f5Wgm.CommentType).FOOTER : (0, $f5Wgm.CommentType).INLINE,
                isCommentsPanelOpen: isObjectSidebarShown && (0, $9wGTI.fg)('confluence-frontend-comments-panel'),
                hasKeyPressed: true,
                context: (0, $9FoVw.NavigationContext).RENDERER,
                isResolved: !navigableInlineCommentRefs.has(nextRef.ref)
            });
        } else // Use old method when unified navigation is disabled
        (0, $7qvmT.handlePanelSelectionAndScroll)({
            threadKey: nextRef.ref,
            isResolved: !navigableInlineCommentRefs.has(nextRef.ref),
            pageMode: pageMode,
            setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey,
            eventEmitter: emitter,
            commentType: nextRef.type,
            scrollCommentsPanelToThread: scrollCommentsPanelToThread,
            shouldScrollCommentsPanel: true,
            hasKeyPressed: true
        });
    }, [
        currentlyRenderedThreads,
        orderedActiveAnnotations,
        currentlySelectedThreadKey,
        pageMode,
        setCurrentlySelectedThreadKey,
        emitter,
        scrollCommentsPanelToThread,
        isObjectSidebarShown
    ]);
    const handleNextCommentNavigation = (0, $42omo.useCallback)(({ action: action, isNavigateToNextUnread: isNavigateToNextUnread })=>{
        //Check if the next inline comment is still in process of being rendered. Otherwise, quickly pressing keys will force comment to open and close instead of navigating
        if (isNextCommentLoading) return;
        setIsNextCommentLoading(true);
        navigateToInlineComment({
            action: action,
            triggeredByKeyboardShortcut: true,
            currentCommentIndex: getCommentIndex(activeHighlight || currentlySelectedThreadKey || ''),
            getCommentIndex: getCommentIndex,
            onNavigationClick: onNavigationClick,
            isEditor: false,
            removeCommentQueryParams: removeCommentQueryParams,
            unresolvedInlineComments: orderedActiveAnnotations,
            createAnalyticsEvent: createAnalyticsEvent,
            contentId: contentId,
            isNavigateToNextUnread: isNavigateToNextUnread,
            unreadInlineComments: unreadInlineComments,
            unreadGeneralComments: unreadGeneralComments,
            footerComments: footerCommentIds,
            scrollToFooterComment: scrollToFooterComment,
            commentsDataMap: commentsDataMap
        });
    }, [
        isNextCommentLoading,
        navigateToInlineComment,
        getCommentIndex,
        activeHighlight,
        currentlySelectedThreadKey,
        onNavigationClick,
        removeCommentQueryParams,
        orderedActiveAnnotations,
        createAnalyticsEvent,
        contentId,
        unreadInlineComments,
        unreadGeneralComments,
        footerCommentIds,
        scrollToFooterComment,
        commentsDataMap
    ]);
    const handleStandaloneCommentNavigation = (0, $42omo.useCallback)((action)=>{
        if (activeHighlight || currentlySelectedThreadKey) {
            // Check if we're navigating to a potentially unloaded footer comment
            const currentIndex = getCommentIndex(activeHighlight || currentlySelectedThreadKey || '');
            const totalComments = [
                ...orderedActiveAnnotations,
                ...footerCommentIds
            ].length;
            const navigatingToPotentiallyUnloadedFooterComment = (0, $izhdc.isNavigatingToPotentiallyUnloadedFooterComment)(action, currentIndex, totalComments, footerCommentsLoadingState);
            if (navigatingToPotentiallyUnloadedFooterComment && (0, $9wGTI.fg)('confluence_frontend_kb_footer_loading')) setPendingStandaloneAction(action);
            else handleNextCommentNavigation({
                isNavigateToNextUnread: false,
                action: action
            });
        } else {
            // No highlight selected, so we navigate to the first inline comment
            const firstInlineCommentMarkerRef = orderedActiveAnnotations[0];
            if (!firstInlineCommentMarkerRef && ((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? footerCommentThreads.length === 0 : true)) {
                // No active inline comments or footer comments found, but footer is not yet loaded - load footer comments and try again
                if (footerCommentsLoadingState === (0, $8i27m.FooterCommentsLoadingStateType).NOT_LOADED && (0, $9wGTI.fg)('confluence_frontend_kb_footer_loading')) setPendingStandaloneAction(action);
                return;
            }
            if (firstInlineCommentMarkerRef) openInlineComment(firstInlineCommentMarkerRef);
            else if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) scrollToFooterComment(footerCommentThreads[0]?.id);
        }
    }, [
        activeHighlight,
        currentlySelectedThreadKey,
        getCommentIndex,
        orderedActiveAnnotations,
        footerCommentIds,
        footerCommentsLoadingState,
        handleNextCommentNavigation,
        footerCommentThreads,
        openInlineComment,
        scrollToFooterComment
    ]);
    const handleCommentNavigation = (0, $42omo.useCallback)((action)=>{
        // Define behavior when the comments panel is shown - panel FG is a prereq for nav, so has to be checked first
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('confluence-frontend-comments-panel') && isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel) handlePanelCommentNavigation(action);
        else // Comments panel not shown
        handleStandaloneCommentNavigation(action);
    }, [
        isObjectSidebarShown,
        panel?.id,
        handlePanelCommentNavigation,
        handleStandaloneCommentNavigation
    ]);
    (0, $dkkKv.useActiveCommentsQuery)({
        pageId: contentId || '',
        skip: !triggeredByUnreadKeyboardShortcut || alreadyFetchedInitialData || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false),
        onCompletedFn: ()=>{
            setAlreadyFetchedInitialData(true);
        }
    });
    // The flow is setPendingStandaloneAction --> load footer comments --> updates footerCommentIds --> retrigger KB shortcut with updated data
    const shouldLoadFooterComments = pendingStandaloneAction !== null;
    (0, $dkkKv.useActiveCommentsQuery)({
        pageId: contentId || '',
        skip: !shouldLoadFooterComments || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false),
        fetchPolicy: shouldLoadFooterComments ? 'network-only' : 'cache-only',
        type: (0, $f5Wgm.CommentType).FOOTER
    });
    (0, $42omo.useEffect)(()=>{
        if (pendingStandaloneAction !== null) {
            handleStandaloneCommentNavigation(pendingStandaloneAction);
            setPendingStandaloneAction(null);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        footerCommentIds
    ]);
    const handleNextUnreadNavigation = (0, $42omo.useCallback)(()=>{
        if (!alreadyFetchedInitialData) {
            //This will trigger the ActiveComments query if it's not already fetched
            setTriggeredByUnreadKeyboardShortcut(true);
            //Exit because the comment data won't be available yet to navigate to
            return;
        }
        //unread panel navigation
        if (isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel && (0, $9wGTI.fg)('confluence-frontend-comments-panel')) {
            let nextThreadKey = '';
            let nextCommentType = (0, $8i27m.CommentType).GENERAL;
            if (!currentlySelectedThreadKey) {
                if (unreadInlineComments.length > 0) {
                    nextThreadKey = unreadInlineComments[0];
                    nextCommentType = (0, $8i27m.CommentType).INLINE;
                } else nextThreadKey = unreadGeneralComments[0];
            } else {
                nextThreadKey = (0, $aHcFH.getNextUnreadThreadKey)(getCommentIndex(currentlySelectedThreadKey ?? '') + 1, [
                    ...orderedActiveAnnotations,
                    ...footerCommentIds
                ], [
                    ...unreadInlineComments,
                    ...unreadGeneralComments
                ]) ?? '';
                if (unreadInlineComments.includes(nextThreadKey)) nextCommentType = (0, $8i27m.CommentType).INLINE;
            }
            // Use unified keyboard shortcut navigation for panel navigation when feature is enabled
            if ((0, $9wGTI.fg)('confluence_comments_unified_navigation')) {
                // Handle panel selection state management in the listener
                setCurrentlySelectedThreadKey(nextThreadKey);
                (0, $9FoVw.handleKeyboardShortcutNavigation)({
                    scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                    block: 'center',
                    annotationId: nextThreadKey,
                    commentType: nextCommentType === (0, $8i27m.CommentType).GENERAL ? (0, $f5Wgm.CommentType).FOOTER : (0, $f5Wgm.CommentType).INLINE,
                    isCommentsPanelOpen: isObjectSidebarShown && (0, $9wGTI.fg)('confluence-frontend-comments-panel'),
                    hasKeyPressed: true,
                    context: (0, $9FoVw.NavigationContext).RENDERER,
                    shortcutType: (0, $9FoVw.ShortcutType).UNREAD
                });
            } else // Use old method when unified navigation is disabled
            (0, $7qvmT.handlePanelSelectionAndScroll)({
                threadKey: nextThreadKey,
                isResolved: false,
                pageMode: pageMode,
                setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey,
                eventEmitter: emitter,
                commentType: nextCommentType,
                scrollCommentsPanelToThread: scrollCommentsPanelToThread,
                shouldScrollCommentsPanel: true
            });
            return;
        }
        if (activeHighlight || currentlySelectedThreadKey) handleNextCommentNavigation({
            isNavigateToNextUnread: true,
            action: 'next'
        });
        else {
            if (unreadInlineComments.length + unreadGeneralComments.length === 0) return;
            if (unreadInlineComments[0]) openInlineComment(unreadInlineComments[0]);
            else scrollToFooterComment(unreadGeneralComments[0]);
        }
    }, [
        isObjectSidebarShown,
        panel?.id,
        handleNextCommentNavigation,
        unreadInlineComments,
        activeHighlight,
        openInlineComment,
        scrollToFooterComment,
        currentlySelectedThreadKey,
        unreadGeneralComments,
        emitter,
        footerCommentIds,
        getCommentIndex,
        orderedActiveAnnotations,
        pageMode,
        scrollCommentsPanelToThread,
        setCurrentlySelectedThreadKey,
        alreadyFetchedInitialData
    ]);
    (0, $42omo.useEffect)(()=>{
        if (unreadInlineComments.length + unreadGeneralComments.length > 0 && alreadyFetchedInitialData && triggeredByUnreadKeyboardShortcut) {
            // This handles the case where user triggers unread keyboard shortcut when the comments data isn't fetched yet.
            // We need to wait for the data to be fetched before calling handleNextUnreadNavigation
            setTriggeredByUnreadKeyboardShortcut(false);
            // Putting this behind a timeout because need to wait for triggeredByUnreadKeyboardShortcut to be set to false otherwise got called multiple times
            setTimeout(()=>{
                handleNextUnreadNavigation();
            }, 100);
        }
    }, [
        unreadInlineComments,
        unreadGeneralComments,
        handleNextUnreadNavigation,
        alreadyFetchedInitialData,
        triggeredByUnreadKeyboardShortcut,
        setTriggeredByUnreadKeyboardShortcut
    ]);
    const openCommentEditorShortcutCb = (e)=>{
        e.preventDefault();
        // This check is necessary to see which keyboard shortcut was used so it can be sent to analytics.
        // e.key is used to get the key that was pressed according to the current keyboard layout.
        // We compare with CREATE_COMMENT_SHORTCUT because it is a single-letter keyboard shortcut.
        // It's more difficult to compare with UNIVERSAL_OPEN_COMMENT_EDITOR because it includes modifiers.  Modifiers which change what e.key maps to depending on the keyboard layout.
        const shortcut = e.key === (0, $gnkil.CREATE_COMMENT_SHORTCUT) ? (0, $gnkil.CREATE_COMMENT_SHORTCUT) : (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR);
        if (canAddComments || !(0, $9wGTI.fg)('confluence_fe_add_comment_kb_check_permission')) {
            if (document.querySelector('[data-testid="highlightActionsPopup"]')) {
                const createButton = document.querySelector('#create-inline-comment-button');
                // if the disabled attribute is there, and comes back as an empty string, it is disabled.
                // If the disabled attribute is not there, it will come back as null
                const createButtonIsDisabled = createButton?.getAttribute('disabled') === '';
                // If createButton is not found or is disabled, do nothing.
                // This handles the case when hovering over media (image/video) objects in renderer.
                // In this scenario, a `highlightActionsPopup` is shown but the Comment button (which
                // has a different id) behaves differently: if any comment exists on the media object,
                // button click opens it as standalone; otherwise button click opens CreateComment.
                // Keyboard shortcut is disabled for this scenario.
                const createButtonIsEnabled = createButton && createButton?.getAttribute('disabled') !== '';
                if ((0, $9wGTI.fg)('confluence_fe_create_inline_comment_exp_coverage') ? createButtonIsEnabled : !createButtonIsDisabled) handleCommentButtonClick({
                    dialogs: dialogs,
                    shortcut: shortcut,
                    experienceAttributes: {
                        entryPoint: 'keyboardShortcut'
                    }
                });
            } else {
                // Check if we should show sticky draft instead of scrolling to object comment wrapper
                const isShowStickyDraft = !isObjectCommentWrapperVisible && (addFooterCommentAdf || expanded) && footerEditorEntry !== (0, $fNzRA.AddFooterCommentMode).STICKY_DRAFT && (0, $9wGTI.fg)('confluence_comment_sticky_footer_enabled');
                if (!expanded) expandCommentContainer({
                    entryPoint: 'keyboardShortcutView'
                });
                if (isShowStickyDraft || !isObjectCommentWrapperVisible && (0, $9wGTI.fg)('confluence_comment_expand_footer_editor')) setFooterEditorEntry((0, $fNzRA.AddFooterCommentMode).STICKY_DRAFT);
                else document.querySelector(`[data-testid='object-comment-wrapper']`)?.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        }
        sendKeyboardShortcutAnalytics(shortcut);
    };
    if (!isFabricPage) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "comments-shortcut-listener"
    }, (0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_SELECT_COMMENT_SHORTCUT),
        listener: ()=>{
            const openComment = document.getElementById('renderer-comments-sidebar') || document.getElementById(`comment-thread-${currentlySelectedThreadKey}-container`);
            if (openComment) {
                openComment.setAttribute('tabIndex', '-1');
                openComment.focus();
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_NEXT_COMMENT_SHORTCUT),
        deprecatedAccelerator: (0, $gnkil.NEXT_COMMENT_SHORTCUT),
        listener: ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: 'keyboard-navigation'
            });
            (0, $4EKKB.selectInlineComment).debug('keyboard navigation to next comment', {
                // whenTriggered props added to help debug on Hello (for reproducing issues)
                activeHighlightWhenTriggered: activeHighlight,
                currentlySelectedThreadKeyWhenTriggered: currentlySelectedThreadKey
            });
            handleCommentNavigation('next');
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_PREV_COMMENT_SHORTCUT),
        deprecatedAccelerator: (0, $gnkil.PREV_COMMENT_SHORTCUT),
        listener: ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: 'keyboard-navigation'
            });
            (0, $4EKKB.selectInlineComment).debug('keyboard navigation to previous comment', {
                // whenTriggered props added to help debug on Hello (for reproducing issues)
                activeHighlightWhenTriggered: activeHighlight,
                currentlySelectedThreadKeyWhenTriggered: currentlySelectedThreadKey
            });
            handleCommentNavigation('previous');
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT),
        listener: ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: 'keyboard-navigation'
            });
            (0, $4EKKB.selectInlineComment).debug('Keyboard navigation to next unread comment', {
                // whenTriggered props added to help debug on Hello (for reproducing issues)
                activeHighlightWhenTriggered: activeHighlight,
                currentlySelectedThreadKeyWhenTriggered: currentlySelectedThreadKey
            });
            handleNextUnreadNavigation();
        }
    }), (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: (0, $gnkil.CREATE_COMMENT_SHORTCUT),
        accelerator: (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR),
        listener: (e)=>openCommentEditorShortcutCb(e)
    }));
};
const $c392465906bed01c$export$c1f9f1253d923bc1 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).COMMENTS
})((0, $inDu6.withDialogs)($c392465906bed01c$var$ViewCommentShortcutListenerComponent));
module.exports["ViewCommentShortcutListener"] = $c392465906bed01c$export$c1f9f1253d923bc1;

});

parcelRegister("6pBXK", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $95494d62ea246593$export$ffdc57aecb97ae41 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "nmqvg",
    name: "ReadingAidsAcronymsHighlighter",
    loader: async ()=>(await (parcelRequire("i0OOf"))).ReadingAidsAcronymsHighlighter
});
module.exports["ReadingAidsAcronymsHighlighter"] = $95494d62ea246593$export$ffdc57aecb97ae41;

});

parcelRegister("i0OOf", function(module, exports) {

let $d1cfa3cd4981c492$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d1cfa3cd4981c492$var$load("2YffH"),
    $d1cfa3cd4981c492$var$load("iDB1L"),
    $d1cfa3cd4981c492$var$load("5WgIL"),
    $d1cfa3cd4981c492$var$load("1FvvC"),
    $d1cfa3cd4981c492$var$load("6mHrv"),
    $d1cfa3cd4981c492$var$load("9zkjw"),
    $d1cfa3cd4981c492$var$load("jQiOa"),
    $d1cfa3cd4981c492$var$load("1QdXB"),
    $d1cfa3cd4981c492$var$load("eEyVs"),
    $d1cfa3cd4981c492$var$load("7RXky"),
    $d1cfa3cd4981c492$var$load("lVO3w"),
    $d1cfa3cd4981c492$var$load("hyzoX"),
    $d1cfa3cd4981c492$var$load("h9Ed7"),
    $d1cfa3cd4981c492$var$load("9A0ig"),
    $d1cfa3cd4981c492$var$load("9MSTM"),
    $d1cfa3cd4981c492$var$load("aYx1O"),
    $d1cfa3cd4981c492$var$load("86sUJ"),
    $d1cfa3cd4981c492$var$load("8VzWv"),
    $d1cfa3cd4981c492$var$load("8YSo7"),
    $d1cfa3cd4981c492$var$load("gryT8"),
    $d1cfa3cd4981c492$var$load("9XYQ9"),
    $d1cfa3cd4981c492$var$load("kiGNy"),
    $d1cfa3cd4981c492$var$load("St9Nk"),
    $d1cfa3cd4981c492$var$load("8JZKd"),
    $d1cfa3cd4981c492$var$load("7jH9e"),
    $d1cfa3cd4981c492$var$load("6FuHS"),
    $d1cfa3cd4981c492$var$load("eyaRC"),
    $d1cfa3cd4981c492$var$load("drv5I"),
    $d1cfa3cd4981c492$var$load("g9CVe"),
    $d1cfa3cd4981c492$var$load("jTaSF"),
    $d1cfa3cd4981c492$var$load("36QeB"),
    $d1cfa3cd4981c492$var$load("8fXIr"),
    $d1cfa3cd4981c492$var$load("dVkhd"),
    $d1cfa3cd4981c492$var$load("hv4mn"),
    $d1cfa3cd4981c492$var$load("hhss7"),
    $d1cfa3cd4981c492$var$load("7jSfd"),
    $d1cfa3cd4981c492$var$load("4HZlX"),
    $d1cfa3cd4981c492$var$load("kDqHr"),
    $d1cfa3cd4981c492$var$load("6wr18"),
    $d1cfa3cd4981c492$var$load("kjZZD"),
    $d1cfa3cd4981c492$var$load("ht5OT"),
    $d1cfa3cd4981c492$var$load("sj9Xz"),
    $d1cfa3cd4981c492$var$load("Wowvf"),
    $d1cfa3cd4981c492$var$load("37ldp"),
    $d1cfa3cd4981c492$var$load("dTsOE"),
    $d1cfa3cd4981c492$var$load("fqXA9"),
    $d1cfa3cd4981c492$var$load("ipoo6"),
    $d1cfa3cd4981c492$var$load("ffEVr"),
    $d1cfa3cd4981c492$var$load("f1NVy"),
    $d1cfa3cd4981c492$var$load("d6s42"),
    $d1cfa3cd4981c492$var$load("7e13v"),
    $d1cfa3cd4981c492$var$load("aqr2D"),
    $d1cfa3cd4981c492$var$load("7EorR"),
    $d1cfa3cd4981c492$var$load("avRkh"),
    $d1cfa3cd4981c492$var$load("6mkG4")
]).then(()=>parcelRequire('6vx1i'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("39nIX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");

var $398ES = parcelRequire("398ES");


var $7d2Nc = parcelRequire("7d2Nc");


var $5RuD9 = parcelRequire("5RuD9");


var $jhifQ = parcelRequire("jhifQ");


/* View Mode Exports */ const $166368e9a123fc4e$var$InlineCommentsLoaderPaint = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "fZs06",
    name: "InlineCommentsLoaderPaint",
    loader: async ()=>(await (parcelRequire("4VOOd"))).InlineComments,
    loading: (0, $5RuD9.InlineCommentsLoading)
});

const $166368e9a123fc4e$var$InlineCommentsLoaderLazy = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "i8DIK",
    name: "InlineCommentsLoaderLazy",
    loader: async ()=>(await (parcelRequire("4VOOd"))).InlineComments,
    loading: (0, $5RuD9.InlineCommentsLoading)
});

const $166368e9a123fc4e$var$InlineCommentsLoaderAfterPaint = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "vilgC",
    name: "InlineCommentsLoaderAfterPaint",
    loader: async ()=>(await (parcelRequire("4VOOd"))).InlineComments
});

const $166368e9a123fc4e$var$InlineCommentsLoaderBackground = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "05zPo",
    name: "InlineCommentsLoaderBackground",
    loader: async ()=>(await (parcelRequire("4VOOd"))).InlineComments
});
const $166368e9a123fc4e$var$loaders = {
    [(0, $398ES.LoadingPriority).LAZY]: $166368e9a123fc4e$var$InlineCommentsLoaderLazy,
    [(0, $398ES.LoadingPriority).PAINT]: $166368e9a123fc4e$var$InlineCommentsLoaderPaint,
    [(0, $398ES.LoadingPriority).AFTER_PAINT]: $166368e9a123fc4e$var$InlineCommentsLoaderAfterPaint
};
const $166368e9a123fc4e$export$bceb71dc98e1c75f = ({ loadingPriority: loadingPriority, focusedCommentId: focusedCommentId, ...rest })=>{
    const CommentsLoader = $166368e9a123fc4e$var$loaders[loadingPriority] || $166368e9a123fc4e$var$InlineCommentsLoaderBackground;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, focusedCommentId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
        key: `start-${focusedCommentId}`,
        metric: (0, $jhifQ.FOCUSED_INLINE_COMMENT_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(CommentsLoader, rest));
};
module.exports["InlineCommentsLoader"] = $166368e9a123fc4e$export$bceb71dc98e1c75f;

});

parcelRegister("5RuD9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8uhVX = parcelRequire("8uhVX");


var $beAZw = parcelRequire("beAZw");

const $58d1b0f1d68392b5$var$checkForSSRFocusedComment = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) return true;
    return false;
};
const $58d1b0f1d68392b5$export$d174da0f28ffce9e = ()=>{
    return $58d1b0f1d68392b5$var$checkForSSRFocusedComment() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8uhVX.FocusedInlineComment), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $beAZw.InlineCommentsLoadingSkeleton), null);
};
module.exports["InlineCommentsLoading"] = $58d1b0f1d68392b5$export$d174da0f28ffce9e;

});

parcelRegister("8uhVX", function(module, exports) {
/* FocusedInlineComment.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $2XqLN = parcelRequire("2XqLN");


var $8C5kA = parcelRequire("8C5kA");


var $xQxzY = parcelRequire("xQxzY");


var $7zgzO = parcelRequire("7zgzO");


var $ep3mz = parcelRequire("ep3mz");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");




var $8Ya23 = parcelRequire("8Ya23");


var $9CnRS = parcelRequire("9CnRS");


var $666Tc = parcelRequire("666Tc");


var $aHcFH = parcelRequire("aHcFH");



var $f8HSn = parcelRequire("f8HSn");


var $qYtBT = parcelRequire("qYtBT");


var $dQJV7 = parcelRequire("dQJV7");


var $c04ej = parcelRequire("c04ej");

const $d9a6205ec51ab13a$var$parseContent = (0, $2XqLN.default)((content)=>{
    if (!content?.length) return null;
    try {
        return JSON.parse(content);
    } catch (error) {
        return null;
    }
});
const $d9a6205ec51ab13a$var$FocusedInlineCommentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $666Tc.SidebarContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_162hus6": (0, $7sObp.default)(__cmplp.offset, "px")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_154i1odf _zqk2124n _16tr13gf",
            __cmplp.showSkeleton ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ])
    });
}); /* Comment Editor CSS*/ 
const $d9a6205ec51ab13a$var$EditorContainerSSR = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $666Tc.EditorContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_10v51b66 _1fnwia51 _116r1l7b _kv9q2smr _12i31ul9 _j980usvi _1esn1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $d9a6205ec51ab13a$var$CommentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFocused: isFocused, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt49l6b _12ji1r31 _1qu2glyw _12y31o36 _1kl7idpf _x3doidpf _1e0c1txw _2lx21bp4 _1ragidpf _ha8hi7uo",
            __cmplp.isFocused && "_11q71856",
            __cmplp.className
        ])
    });
});
const $d9a6205ec51ab13a$export$622cea445a1c5b7d = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) return window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['markerRefOffset'];
    return 0;
}; // Makes sure to only show focusedInlineCommentSSR if the page was ssr'd
const $d9a6205ec51ab13a$export$db871669e60ed1cb = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) return true;
    return false;
};
const $d9a6205ec51ab13a$export$7afb8d400fcdf579 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const focusedCommentId = match?.query.focusedCommentId; // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $8Ya23.FocusedInlineCommentQuery), {
        variables: {
            commentId: focusedCommentId,
            contentId: contentId
        },
        skip: !(contentId && focusedCommentId)
    });
    let commentData;
    let isTopLevelComment = true; /* If focusedCommentId is a reply grab top-level comment Data from ancestors.
                                 If ancestors is non-empty it means focusedCommentId is a reply*/ 
    if (data?.comments?.nodes[0]?.ancestors.length > 0) {
        commentData = data?.comments?.nodes[0]?.ancestors?.[0];
        isTopLevelComment = false;
    } else commentData = data?.comments?.nodes[0];
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['isTopLevelComment'] = isTopLevelComment;
    const content = data?.content?.nodes?.[0];
    const operations = content?.operations || [];
    const canCreateComments = Boolean(operations.find((op)=>op?.operation === 'create' && op?.targetType === 'comment'));
    const topCommentUserId = commentData?.author?.accountId;
    const topCommentUserAvatar = commentData?.author?.profilePicture?.path;
    const topCommentDisplayName = commentData?.author?.displayName;
    const commentId = commentData?.id;
    const when = commentData?.version?.when;
    const commentContent = commentData?.body?.value;
    const permissionType = commentData?.author?.permissionType;
    const currentUserAvatarUrl = data?.user?.photos[0].value || null;
    const currentUserDisplayName = data?.user?.displayName || null;
    const currentUserId = data?.user?.id;
    const adf = $d9a6205ec51ab13a$var$parseContent(commentContent);
    const renderReplies = ()=>{
        const replies = commentData?.replies || [];
        return replies.map((reply)=>{
            const adf = $d9a6205ec51ab13a$var$parseContent(reply?.body?.value);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d9a6205ec51ab13a$var$CommentContainer, {
                key: reply?.id,
                isFocused: focusedCommentId === reply?.id,
                "data-comment-id": reply?.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f8HSn.CommentAuthor), {
                commentMode: "view",
                userId: reply?.author?.accountId,
                avatarUrl: reply?.author?.profilePicture?.path,
                displayName: reply?.author?.displayName,
                date: reply?.version?.when,
                permissionType: reply?.author?.permissionType
            }), adf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c04ej.CommentRenderer), {
                adf: adf
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dQJV7.CommentActions), {
                isReply: true,
                permissions: reply?.permissions
            }));
        });
    }; // Scroll to focusedInlineComment if it's out of the screen
    const scrollOffset = window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment'] && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['scrollOffset'];
    if (scrollOffset) window.scrollTo({
        top: scrollOffset
    });
    const { commentIndex: commentIndex, totalComments: totalComments } = (0, $aHcFH.getCommentIndexAndCount)();
    if (data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COLLABORATION
    }, undefined, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d9a6205ec51ab13a$var$FocusedInlineCommentContainer, {
        mode: "view",
        id: "focused-inline-comment-sidebar-skeleton",
        "data-testid": "focused-inline-comment-sidebar-skeleton",
        showSkeleton: $d9a6205ec51ab13a$export$db871669e60ed1cb(),
        offset: $d9a6205ec51ab13a$export$622cea445a1c5b7d()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $qYtBT.CommentHeader), {
        commentIndex: commentIndex,
        totalComments: totalComments
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d9a6205ec51ab13a$var$CommentContainer, {
        tabIndex: -1,
        "data-comment-id": commentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f8HSn.CommentAuthor), {
        commentMode: "view",
        userId: topCommentUserId,
        avatarUrl: topCommentUserAvatar,
        displayName: topCommentDisplayName,
        date: when,
        permissionType: permissionType,
        size: "medium"
    }), adf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c04ej.CommentRenderer), {
        adf: adf
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dQJV7.CommentActions), {
        permissions: commentData?.permissions,
        isReply: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.ReplyListContainer), {
        "data-testid": "reply-container"
    }, renderReplies()), canCreateComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.NewReplyContainer), {
        mode: "view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d9a6205ec51ab13a$var$EditorContainerSSR, {
        isReply: true,
        mode: "view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f8HSn.CommentAuthor), {
        commentMode: "reply",
        userId: currentUserId,
        avatarUrl: currentUserAvatarUrl,
        displayName: currentUserDisplayName,
        date: when,
        permissionType: permissionType,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("input", {
        disabled: true,
        placeholder: formatMessage((0, $9CnRS.i18n).replyPlaceholder)
    })))), undefined);
    return null;
};
module.exports["FocusedInlineComment"] = $d9a6205ec51ab13a$export$7afb8d400fcdf579;

});

parcelRegister("f8HSn", function(module, exports) {
/* CommentAuthor.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $fs6LW = parcelRequire("fs6LW");


var $gvWVt = parcelRequire("gvWVt");


var $1YXTQ = parcelRequire("1YXTQ");


var $7tI6B = parcelRequire("7tI6B");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$DateContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2lx2vrvc _1n261q9c _1e0c1txw _4cvr1h6o _102e1o8v _1mil78py _7wy0glyw _1t4pd34b _1plv1j28 _zmp8d34b _9b8id34b _1blwd34b",
            __cmplp.className
        ])
    });
});
const $b0598b16360d1677$var$AuthorContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { commentMode: commentMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _uvzw1snc _12rjagmp _1vjrvv82 _1dtc4viv _jva41snc _wkreagmp _gcmzvv82 _5xy14viv _1msj4viv",
            __cmplp.commentMode !== 'reply' ? "_18u01i6y" : "_18u01kw7",
            __cmplp.commentMode === 'view' && "_n3tdu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$AvatarWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { commentMode: commentMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _u5f3u2gc",
            __cmplp.commentMode === 'view' && "_4t3i1wpv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$ProfileLinkContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _2lx2vrvc _4cvr1h6o _17rp1o8v _cpznidpf _1s79idpf _amufidpf _x966idpf _387xglyw _14l5d34b _1ptk1j28 _19gdazsu _1e6pazsu _1gidazsu _zer61snc _7ec9agmp _1bkkvv82 _z01g4viv _101q1snc _vnv1agmp _94evvv82 _kvyv4viv _18t3x3d0 _1t4p4viv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$LozengeWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19bvu2gc _s7n4jp4b",
            __cmplp.className
        ])
    });
});
const $b0598b16360d1677$export$d05a2f5fbf67a6d7 = ({ commentMode: commentMode, userId: userId, date: date, displayName: displayName, avatarUrl: avatarUrl, permissionType: permissionType, size: size })=>{
    const isDateShown = commentMode === 'view' && date;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b0598b16360d1677$var$AuthorContainer, {
        commentMode: commentMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b0598b16360d1677$var$AvatarWrapper, {
        commentMode: commentMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fs6LW.ProfileAvatar), {
        userId: userId,
        src: avatarUrl,
        size: size,
        trigger: "click",
        name: displayName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b0598b16360d1677$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b0598b16360d1677$var$ProfileLinkContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, displayName), permissionType === (0, $7tI6B.SitePermissionType).EXTERNAL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b0598b16360d1677$var$LozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gvWVt.ExternalCollaboratorUserLozenge), null)) : null), isDateShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b0598b16360d1677$var$DateContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
        date: date
    })))));
};
module.exports["CommentAuthor"] = $b0598b16360d1677$export$d05a2f5fbf67a6d7;

});

parcelRegister("qYtBT", function(module, exports) {
/* CommentHeader.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $hmuev = parcelRequire("hmuev");


var $9VJDA = parcelRequire("9VJDA");


var $7N1sB = parcelRequire("7N1sB");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9359cd91b07ea16f$var$SidebarHeader = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4ba4q _kqswh2mm _1e0c1txw _4t3i10yn _ca0qutpp _1hadu49m _wzsr12b0 _brspgktf _11pzgktf _p7gl1wug _1p0qutpp _etmr1b66 _13yvyfq0",
            __cmplp.className
        ])
    });
});
const $9359cd91b07ea16f$export$af4e8b81cdb5570a = ({ commentIndex: commentIndex, totalComments: totalComments })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($9359cd91b07ea16f$var$SidebarHeader, {
        "data-testid": "inline-comment-ssr-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7N1sB.CommentNavigation), {
        commentsCount: totalComments,
        currentCommentIndex: commentIndex,
        goToNextInlineComment: ()=>{},
        goToPrevInlineComment: ()=>{}
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        id: "dropdown"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
        label: "overflow-menu-icon",
        color: "var(--ds-icon-disabled, #080F214A)",
        spacing: "spacious"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        id: "close-icon-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
        label: "close-icon",
        color: `${"var(--ds-icon-disabled, #080F214A)"}`,
        spacing: "none"
    })));
};
module.exports["CommentHeader"] = $9359cd91b07ea16f$export$af4e8b81cdb5570a;

});

parcelRegister("dQJV7", function(module, exports) {
/* CommentActions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gtD4K = parcelRequire("gtD4K");


var $bFPHx = parcelRequire("bFPHx");


var $666Tc = parcelRequire("666Tc");


var $9CnRS = parcelRequire("9CnRS");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e6040be4eb93366f$var$ActionsContainerSSR = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $666Tc.ActionsContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1tke10yn _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $e6040be4eb93366f$var$ActionItem = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2lx2vrvc _1n261q9c _1e0c116y _syaz1rpy _19pk1b66 _xrwlcs5v _144bkb7n _14p1f1ug _ekv61o8v _6wjiesu3 _43ds1oa5 _1pzmusic _ep9t1b66 _1tzjf4df _8bo21mp2 _nqnu1rpy _d32v1rpy",
            __cmplp.className
        ])
    });
});
const $e6040be4eb93366f$var$ActionButton = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _12ji1r31 _1qu21kw7 _12y31o36 _syaz1kw7 _1wyb1kw7 _80omtlke",
            __cmplp.className
        ])
    });
});
const $e6040be4eb93366f$export$e75a036919cd8d68 = ({ isReply: isReply, permissions: permissions })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6040be4eb93366f$var$ActionsContainerSSR, null, permissions.isResolvable && !isReply && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6040be4eb93366f$var$ActionItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6040be4eb93366f$var$ActionButton, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).resolve))), permissions.isEditable && isReply && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6040be4eb93366f$var$ActionItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6040be4eb93366f$var$ActionButton, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).edit))), permissions.isRemovable && isReply && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6040be4eb93366f$var$ActionItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e6040be4eb93366f$var$ActionButton, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $9CnRS.i18n).delete))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bFPHx.ReactionsPlaceholder), null));
module.exports["CommentActions"] = $e6040be4eb93366f$export$e75a036919cd8d68;

});

parcelRegister("c04ej", function(module, exports) {
/* CommentRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $bzqa9 = parcelRequire("bzqa9");


var $hEeUR = parcelRequire("hEeUR");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $61a27fe9845a1cb4$var$CommentRendererContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _ca0qutpp _n3tdutpp",
            __cmplp.className
        ])
    });
});
const $61a27fe9845a1cb4$export$ce6d3ea87eba7794 = ({ adf: adf })=>{
    const eventHandlers = (0, $bzqa9.useEventHandlers)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($61a27fe9845a1cb4$var$CommentRendererContainer, {
        id: "ssr-comment-renderer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hEeUR.ADFRenderer), {
        document: adf,
        appearance: "comment",
        eventHandlers: eventHandlers
    }));
};
module.exports["CommentRenderer"] = $61a27fe9845a1cb4$export$ce6d3ea87eba7794;

});

parcelRegister("beAZw", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $rVJpV = parcelRequire("rVJpV");


var $666Tc = parcelRequire("666Tc");

const $c9d0ea73f4f989e9$export$bb9f90f28a3a4c80 = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['clickedInlineHighlightElements'] && Array.isArray(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['clickedInlineHighlightElements'])) return Boolean(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['clickedInlineHighlightElements'].length);
    return false;
};
const $c9d0ea73f4f989e9$export$e90f33bd7f6da077 = ({ offset: offset = 0 })=>{
    /* For SSR check window object or use offset if passed */ // Previously, clicking on a comment via the inline comment button would still generate an offset.
    // That meant that on transitions, the loading skeleton would still flicker, so we check for window.__SSR_RENDERED__ as well
    /// to prevent the flicker on transitions.
    const sideBarOffset = window.__SSR_RENDERED__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['sidebarCommentOffset'] || offset;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.LoadingSkeletonContainer), {
        id: "inline-comment-sidebar-skeleton",
        "data-testid": "inline-comment-sidebar-skeleton",
        showSkeleton: $c9d0ea73f4f989e9$export$bb9f90f28a3a4c80() || Boolean(offset),
        offset: sideBarOffset,
        mode: "view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $rVJpV.LoadingSkeletonChildren), null));
};
module.exports["InlineCommentsLoadingSkeleton"] = $c9d0ea73f4f989e9$export$e90f33bd7f6da077;

});

parcelRegister("rVJpV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");


var $9hlns = parcelRequire("9hlns");


var $hmuev = parcelRequire("hmuev");


var $9VJDA = parcelRequire("9VJDA");


var $666Tc = parcelRequire("666Tc");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$SkeletonContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt4pxbi _16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4pxbi _16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$CommentSkeletonRow = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { flex: flex, useColumnDirection: useColumnDirection, marginTop: marginTop, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_flb7sw": (0, $7sObp.default)(__cmplp.flex),
                "--_11vu6jx": (0, $7sObp.default)(__cmplp.marginTop, "px")
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_1e0c1txw _19pk4hp3",
                __cmplp.flex ? "_kkes1ubm" : "_16jlkb7n _1o9zkb7n _i0dlf1ug",
                __cmplp.useColumnDirection ? "_2lx21bp4" : "_2lx2vrvc",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { flex: flex, useColumnDirection: useColumnDirection, marginTop: marginTop, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_flb7sw": (0, $7sObp.default)(__cmplp.flex),
            "--_11vu6jx": (0, $7sObp.default)(__cmplp.marginTop, "px")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _19pk4hp3",
            __cmplp.flex ? "_kkes1ubm" : "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.useColumnDirection ? "_2lx21bp4" : "_2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $f5ae94c9feb318d8$var$CommentAuthorSkeleton = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rko1rr0 _4t3izwfg _1bsbzwfg _bfhkizff",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1rr0 _4t3izwfg _1bsbzwfg _bfhkizff",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$CommentSkeletonLine = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { marginBottom: marginBottom, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_iz5w78": (0, $7sObp.default)(__cmplp.marginBottom, "px"),
                "--_10ib6lf": (0, $7sObp.default)(__cmplp.height, "px"),
                "--_1gljcou": (0, $7sObp.default)(__cmplp.width, "px")
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_2rko1l7b _bfhkizff _1bsb1rkg",
                typeof __cmplp.marginBottom === "number" ? "_otyr1s4l" : "_otyrrdoj",
                __cmplp.height ? "_4t3it1jn" : "_4t3iftgi",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { marginBottom: marginBottom, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_iz5w78": (0, $7sObp.default)(__cmplp.marginBottom, "px"),
            "--_10ib6lf": (0, $7sObp.default)(__cmplp.height, "px"),
            "--_1gljcou": (0, $7sObp.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko1l7b _bfhkizff _1bsb1rkg",
            typeof __cmplp.marginBottom === 'number' ? "_otyr1s4l" : "_otyrrdoj",
            __cmplp.height ? "_4t3it1jn" : "_4t3iftgi",
            __cmplp.className
        ])
    });
});
const $f5ae94c9feb318d8$var$SpinnerContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _19pku2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _19pku2gc",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$SidebarHeader = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt41fsj _kqswh2mm _1e0c1txw _1bah1yb4 _4t3i10yn",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41fsj _kqswh2mm _1e0c1txw _1bah1yb4 _4t3i10yn",
            __cmplp.className
        ])
    });
});
const $f5ae94c9feb318d8$var$CloseButton = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $666Tc.InlineHeaderButton) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u014y2 _4t3i1tcg _1bsb1tcg",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = (0, $666Tc.InlineHeaderButton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u014y2 _4t3i1tcg _1bsb1tcg",
            __cmplp.className
        ])
    });
});
const $f5ae94c9feb318d8$var$NavContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $666Tc.NavigationContainer) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = (0, $666Tc.NavigationContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $f5ae94c9feb318d8$export$4857ba7068d0bed8 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_19pkidpf _otyridpf _kqswh2mm _bfhkvuon",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19pkidpf _otyridpf _kqswh2mm _bfhkvuon",
            __cmplp.className
        ])
    });
});
const $f5ae94c9feb318d8$export$a42ae5e40534ea56 = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(7);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.InlineHeaderButton), {
            "data-cy": "inline-nav-previous",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
                label: "",
                color: "var(--ds-icon-disabled, #080F214A)",
                spacing: "spacious",
                size: "small"
            })
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$NavContainer, null, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.InlineHeaderButton), {
            "data-cy": "inline-nav-previous",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                label: "",
                color: "var(--ds-icon-disabled, #080F214A)",
                spacing: "spacious",
                size: "small"
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonLine, {
            width: 30,
            height: 8,
            marginBottom: 0
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
            spacing: "spacious",
            label: "",
            color: "var(--ds-icon-disabled, #080F214A)"
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$SidebarHeader, null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$NavContainer, null, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CloseButton, {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                label: ""
            })
        })));
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonRow, {
            flex: 1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentAuthorSkeleton, null));
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$export$4857ba7068d0bed8, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonRow, {
            flex: 1
        }, t4, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonRow, {
            flex: 5,
            marginTop: 5,
            useColumnDirection: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonLine, {
            width: 81
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonLine, {
            width: 53,
            height: 6
        })))));
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, t3, t5, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "medium"
        })));
        $[6] = t6;
    } else t6 = $[6];
    return t6;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$SidebarHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$NavContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.InlineHeaderButton), {
        "data-cy": "inline-nav-previous",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
            label: "",
            color: "var(--ds-icon-disabled, #080F214A)",
            spacing: "spacious",
            size: "small"
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.InlineHeaderButton), {
        "data-cy": "inline-nav-previous",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: "",
            color: "var(--ds-icon-disabled, #080F214A)",
            spacing: "spacious",
            size: "small"
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonLine, {
        width: 30,
        height: 8,
        marginBottom: 0
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$NavContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-disabled, #080F214A)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CloseButton, {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
            label: ""
        })
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$export$4857ba7068d0bed8, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonRow, {
        flex: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonRow, {
        flex: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentAuthorSkeleton, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonRow, {
        flex: 5,
        marginTop: 5,
        useColumnDirection: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonLine, {
        width: 81
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$CommentSkeletonLine, {
        width: 53,
        height: 6
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f5ae94c9feb318d8$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "medium"
    })));
};
module.exports["LoadingSkeletonChildren"] = $f5ae94c9feb318d8$export$a42ae5e40534ea56;

});

parcelRegister("4VOOd", function(module, exports) {

let $3973e5e8b114d711$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3973e5e8b114d711$var$load("goLL0"),
    $3973e5e8b114d711$var$load("1c1XO"),
    $3973e5e8b114d711$var$load("9Z7qK"),
    $3973e5e8b114d711$var$load("duPDN"),
    $3973e5e8b114d711$var$load("afXyT"),
    $3973e5e8b114d711$var$load("9AHrA"),
    $3973e5e8b114d711$var$load("fqXA9"),
    $3973e5e8b114d711$var$load("ipoo6"),
    $3973e5e8b114d711$var$load("f1NVy"),
    $3973e5e8b114d711$var$load("4Lgj0"),
    $3973e5e8b114d711$var$load("kSJiq"),
    $3973e5e8b114d711$var$load("6wr18"),
    $3973e5e8b114d711$var$load("89WyM"),
    $3973e5e8b114d711$var$load("1QdXB"),
    $3973e5e8b114d711$var$load("cPWI2"),
    $3973e5e8b114d711$var$load("h9Ed7"),
    $3973e5e8b114d711$var$load("lkOIY"),
    $3973e5e8b114d711$var$load("7EorR"),
    $3973e5e8b114d711$var$load("ffEVr"),
    $3973e5e8b114d711$var$load("d6s42"),
    $3973e5e8b114d711$var$load("89Sbl"),
    $3973e5e8b114d711$var$load("5QKVr"),
    $3973e5e8b114d711$var$load("bxFZs"),
    $3973e5e8b114d711$var$load("1PFZq")
]).then(()=>parcelRequire('31yzi'));

});


//# sourceMappingURL=SpaceOverview.1b95bfe7.js.map
